<!-- src/app/time-attendance/scheduling/pages/scheduling-sync/scheduling-sync.component.html -->

<div class="sync-page">
  <header class="schedule-page-header">
    <div>
      <p class="eyebrow">Scheduling Management</p>
      <h1>Sync Schedules</h1>
    </div>

  </header>

  <nav class="schedule-tabs" aria-label="Schedule sections">
    <a class="schedule-tab" routerLink="/scheduling/schedule-groups" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <path d="M16 2v4" />
        <path d="M8 2v4" />
        <path d="M3 10h18" />
      </svg>
      Default Schedules
    </a>

    <a class="schedule-tab" routerLink="/scheduling/user-assign-schedules" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M8 7h12" />
        <path d="M8 12h12" />
        <path d="M8 17h12" />
        <path d="M4 7h.01" />
        <path d="M4 12h.01" />
        <path d="M4 17h.01" />
      </svg>
      Assign Schedules
    </a>

    <a class="schedule-tab" routerLink="/scheduling/scheduling-sync" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M21 12a9 9 0 0 1-9 9 8.5 8.5 0 0 1-6-2.5" />
        <path d="M3 12a9 9 0 0 1 15-6.7" />
        <path d="M18 3v5h-5" />
        <path d="M6 21v-5h5" />
      </svg>
      Sync Schedules
    </a>
  </nav>

  <div
    class="toast show"
    *ngIf="toastMessage"
    [class.success]="toastKind === 'success'"
    [class.error]="toastKind === 'error'"
    [class.warning]="toastKind === 'info'"
    (click)="clearToast()"
    role="status"
    aria-live="polite"
  >
    <img
      class="icon"
      [src]="toastKind === 'success' ? '/success.png' : toastKind === 'error' ? '/fail.png' : '/warning.png'"
      alt=""
      aria-hidden="true"
    />

    <div>
      <div class="toast-title">
        {{ toastKind === 'success' ? 'Success' : toastKind === 'error' ? 'Action needed' : 'Notice' }}
      </div>
      <div class="toast-body">{{ toastMessage }}</div>
    </div>
  </div>

  <div class="page-header">
    <div class="title-block">
      <h2>Scheduling Sync</h2>
      <p class="subtitle">Select a week and sync default schedules into assignments.</p>
    </div>
  </div>

  <div *ngIf="errorMessage" class="inline-error" role="status" aria-live="polite">
    <p class="body">{{ errorMessage }}</p>
    <button type="button" class="icon-btn" (click)="errorMessage = null" aria-label="Close">×</button>
  </div>

  <div class="sync-card">
    <div class="card-head">
      <div class="head-left">
        <h3>Sync week</h3>
        <div class="sub">Search and select the week you want to sync.</div>
      </div>

      <div class="head-right">
        <span class="pill pill-muted" *ngIf="isSyncing">Sync running…</span>
        <span class="pill" *ngIf="!isSyncing && syncState?.status === 'success'">Last sync: Success</span>
        <span class="pill" *ngIf="!isSyncing && syncState?.status === 'error'">Last sync: Error</span>
      </div>
    </div>

    <div class="card-body">
      <div class="week-field">
        <label class="field-label">Week (YYWW)</label>

        <div class="combo">
          <div class="combo-input" (click)="openYyww()" [class.disabled]="isLoading || isSyncing">
            <span class="search-icon" aria-hidden="true">⌕</span>

            <input
              type="text"
              [value]="yywwSearch"
              (input)="onYywwSearchChange($any($event.target).value)"
              placeholder="Type year / YYWW (ex: 2026, 202653)…"
              [disabled]="isLoading || isSyncing"
              aria-label="Search weeks"
            />

            <span class="combo-caret" aria-hidden="true">▾</span>
          </div>

          <div
            class="combo-panel"
            *ngIf="yywwOpen"
            role="dialog"
            aria-label="Weeks"
            (click)="$event.stopPropagation()"
          >
            <div class="combo-help">
              Search updates automatically after you stop typing for <strong>1 second</strong>.
            </div>

            <div class="combo-list" (scroll)="onYywwScroll($event)" aria-live="polite" role="listbox">
              <div class="combo-empty" *ngIf="!yywwIsLoading && !yywwResults.length">
                No weeks found. Try another search.
              </div>

              <button
                type="button"
                class="combo-row"
                *ngFor="let w of yywwResults; trackBy: trackById"
                (click)="selectWeekFromDropdown(w)"
                [class.selected]="selectedYyww?.id === w.id"
                role="option"
                [attr.aria-selected]="selectedYyww?.id === w.id"
              >
                <div class="left">
                  <div class="name">
                    {{ w.fullYearWeek }}
                    <span class="selected-dot" *ngIf="selectedYyww?.id === w.id">Selected</span>
                  </div>

                  <div class="meta" *ngIf="w.startDate && w.endDate">
                    {{ w.startDate }} → {{ w.endDate }}
                  </div>
                </div>

                <div class="right">
                  <div class="tag">Week {{ w.week }}</div>
                </div>
              </button>

              <div class="combo-loading" *ngIf="yywwIsLoading">
                <div class="mini-spinner" aria-hidden="true"></div>
                <span>Loading…</span>
              </div>

              <div class="combo-end" *ngIf="!yywwIsLoading && yywwResults.length">
                <span class="muted">Scroll to load more if available.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="field-help">
          Selected: <strong>{{ selectedWeekSummary }}</strong>
        </div>
      </div>

      <div class="summary-box">
        <span class="summary-label">Ready to sync</span>
        <span class="summary-value">{{ selectedWeekSummary }}</span>
      </div>

      <div class="actions">
        <button
          type="button"
          class="ghost-btn"
          (click)="clearSelectedWeek()"
          [disabled]="!selectedYyww || isSyncing"
        >
          Clear
        </button>

        <button type="button" class="primary-btn" (click)="startSync()" [disabled]="!canSync" title="Run sync">
          <span class="btn-inline">
            <span class="mini-spinner light" *ngIf="isSyncing" aria-hidden="true"></span>
            {{ isSyncing ? 'Syncing…' : 'Sync' }}
          </span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="busy-overlay">
    <div class="spinner"></div>
  </div>
</div>